<template>
	<router-view v-if="isRouterAlive" />
</template>
<script>
	import Theme from '@/utils/theme'
	export default {
		provide() {
			return {
				reload: this.reload
			};
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(function() {
					this.isRouterAlive = true;
				});
			}
		},
		watch: {
			$route: function(e) {
				if (e.path.indexOf('house') == 1) {
					Theme.change('#4d7414')
				} else if (e.path.indexOf('job') == 1) {
					Theme.change('#2c8880')
				} else if (e.path.indexOf('manage') == 1) {
					Theme.change('#409EFF')
				} else {
					Theme.change('#bb0000')
				}
			}
		}
	}
</script>